import React from 'react';
import {useIntl} from "react-intl";
import {shallowEqual, useSelector} from 'react-redux';
import {StyledFieldInput} from "../../../FieldInput";
import {StyledFieldDatepicker} from "../../../FieldDatepicker";
import {StyledFieldSelect} from "../../../FieldSelect";
import {integerValueCanStartFromNull} from "../../../../utils/changeInputValue";
import {optionsTaskStatus} from "../../../../../CustomerDetails/constants/options";
import {filterOptions} from "../../../../utils/options";
import {useTaskAndNotesGridContext} from '../../../../contexts/TaskAndNotesGridContext';
import {getFieldLabel} from '../../utils/getFieldLabel';
import ModalHeader from '../../../ModalHeader';
import ModalContent from '../../../ModalContent';

const TaskVisit = ({header}) => {
  const intl = useIntl();
  const {formik, fieldNames} = useTaskAndNotesGridContext();
  const {users} = useSelector((state) => ({users: state.usersReducer.users}), shallowEqual);

  return (
    <>
      <ModalHeader header={header}/>
      <ModalContent customClassnames={'bg-transparent'}>
        <StyledFieldSelect
          fieldId={fieldNames.responsibleUserID}
          onChange={(option) => formik.setFieldValue(fieldNames.responsibleUserID, option.value)}
          value={filterOptions(formik.values.responsibleUserID)(users)}
          options={users}
          label={getFieldLabel(intl.formatMessage({
            id: 'tab-order-inspections-tasks-popup-responsibleUser',
            defaultMessage: 'Responsible user'
          }))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldSelect
          fieldId={fieldNames.taskStatusID}
          onChange={(option) => formik.setFieldValue(fieldNames.taskStatusID, option.value)}
          value={filterOptions(formik.values.taskStatusID)(optionsTaskStatus)}
          options={optionsTaskStatus}
          label={getFieldLabel(intl.formatMessage({
            id: 'tab-order-inspections-tasks-popup-status',
            defaultMessage: 'Status'
          }))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldDatepicker
          value={formik.values[fieldNames.taskDueDate]}
          onChange={(date) => {
            formik.setFieldValue(fieldNames.taskDueDate, new Date(date));
          }}
          label={getFieldLabel(intl.formatMessage({
            id: 'tab-order-inspections-tasks-popup-dueDate',
            defaultMessage: 'Due date'
          }))}
          customContainerStyles={'py-3'}
        />
        <StyledFieldInput
          fieldId={fieldNames.notes}
          value={formik.values[fieldNames.notes]}
          onChange={(e) => formik.setFieldValue(fieldNames.notes, e.target.value)}
          label={getFieldLabel(intl.formatMessage({
            id: 'tab-order-inspections-tasks-popup-notes',
            defaultMessage: 'Notes'
          }), false)}
          customContainerStyles={'py-3'}
          icon={'/media/common/Edit_primary.svg'}
        />
        <StyledFieldInput
          fieldId={fieldNames.visitContactName}
          value={formik.values[fieldNames.visitContactName]}
          onChange={(e) => formik.setFieldValue(fieldNames.visitContactName, e.target.value)}
          label={getFieldLabel(intl.formatMessage({
            id: 'tab-order-inspections-tasks-popup-contactName',
            defaultMessage: 'Contact name'
          }), false)}
          customContainerStyles={'py-3'}
          icon={'/media/common/User_primary.svg'}
        />
        <StyledFieldInput
          fieldId={fieldNames.visitContactPhone}
          value={formik.values[fieldNames.visitContactPhone]}
          onChange={(e) => {
            formik.setFieldValue(fieldNames.visitContactPhone, integerValueCanStartFromNull(e))
          }}
          label={getFieldLabel(intl.formatMessage({
            id: 'tab-order-inspections-tasks-popup-contactPhone',
            defaultMessage: 'Contact phone'
          }), false)}
          customContainerStyles={'py-3'}
          icon={'/media/common/Phone_primary.svg'}
        />
      </ModalContent>
    </>
  );
}

export default TaskVisit;